import axios from 'axios';
import config from '../constants';

const Axios = axios.create({
	baseURL: config.server.web,
	headers: {
		'Content-Type': 'application/json',
		Authorization: 'Bearer ' + sessionStorage.getItem('token'),
	},
});

export default Axios;
